import { Navigate } from "react-router";
import { useTenantStore } from "./store/tenant/tenant.store";
import { Routes } from "./router/routes";

/**
 * App setup redirector
 *
 * This component is used to redirect the user to the tenant selection page if no tenant is selected.
 * If a tenant is selected, it redirects to the tenant management page.
 */
export function AppSetupRedirector() {
    const { selectedTenant } = useTenantStore();

    // If authenticated but no tenant selected, redirect to tenant selection
    if (!selectedTenant) {
        return <Navigate to={Routes.TenantSelection} />;
    }

    return <Navigate to={`${Routes.Tenant}/${selectedTenant.id}`} />;
}
